import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-10 p-lg-15" }
const _hoisted_3 = { class: "form-check form-check-custom form-check-solid d-flex justify-content-center align-items-start" }
const _hoisted_4 = { class: "form-check form-check-custom form-check-solid d-flex justify-content-center" }
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = { class: "form-check form-check-custom form-check-solid d-flex justify-content-center align-items-start" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, " ID ", -1)
const _hoisted_8 = { class: "d-flex align-items-center gap-2" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "mb-0 pl-2" }
const _hoisted_11 = ["id"]
const _hoisted_12 = {
  class: "carousel-inner w-150px",
  style: {"overflow":"hidden"}
}
const _hoisted_13 = ["data-bs-target"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "carousel-control-prev-icon",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, " Назад ", -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = ["data-bs-target"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  class: "carousel-control-next-icon",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, " Вперёд ", -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "h5 mb-4 word-break_normal" }
const _hoisted_22 = { class: "paragraph" }
const _hoisted_23 = { class: "mb-2 w-180px" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", null, " Причины: ", -1)
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", null, " Не одобрялся ", -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", null, " Причины: ", -1)
const _hoisted_33 = { class: "mb-2 word-break_normal" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, " Не отклонялся ", -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "paragraph" }
const _hoisted_38 = { class: "list" }
const _hoisted_39 = { class: "paragraph" }
const _hoisted_40 = ["title"]
const _hoisted_41 = ["title"]
const _hoisted_42 = { class: "paragraph" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "paragraph" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-document-add fs-3" }, null, -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = {
  class: "btn btn-sm btn-icon btn-active-icon-primary overflow-hidden",
  title: "Редактировать"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-edit fs-3" }, null, -1)
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-delete fs-3" }, null, -1)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = {
  key: 0,
  class: "buttons-wrap"
}
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" Одобрить ")
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" Отклонить ")
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Удалить ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_pre = _resolveComponent("base-pre")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_news_filter = _resolveComponent("news-filter")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_news_filter, {
        onFilterButtonClick: _ctx.filterButtonClick,
        "items-total": _ctx.newsPaginationItemsNumber,
        "pages-total": _ctx.newsPaginationPagesNumber,
        "current-page": _ctx.filterData.page
      }, {
        default: _withCtx(() => [
          _createVNode(_component_base_pre, {
            hide: "",
            title: "filterData data",
            data: _ctx.requestedNewsList
          }, null, 8, ["data"]),
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            border: "",
            data: _ctx.requestedNewsList,
            "scrollbar-always-on": true,
            "table-layout": "fixed",
            "show-header": true,
            resizable: true
          }, {
            empty: _withCtx(() => [
              _createVNode(_component_el_empty, {
                "image-size": 300,
                description: "Ничего не найдено"
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                align: "top",
                class: "py-5 px-0 fw-bolder text-center min-w-50px align-top",
                width: _ctx.calcWidth(50),
                property: "checked"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    (_ctx.requestedNewsList.length > 1)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "checkbox",
                          id: "flexCheckDefault",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkedModel) = $event)),
                          class: "form-check-input",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.switchAllCheckboxes && _ctx.switchAllCheckboxes(...args)))
                        }, null, 512)), [
                          [_vModelCheckbox, _ctx.checkedModel]
                        ])
                      : _createCommentVNode("", true)
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_4, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": ($event: any) => ((scope.row.checked) = $event),
                      class: "form-check-input"
                    }, null, 8, _hoisted_5), [
                      [_vModelCheckbox, scope.row.checked]
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                property: "id",
                label: "ID",
                width: _ctx.calcWidth(110)
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("p", {
                      class: "p-2 mb-0 cursor-pointer",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sortNews()))
                    }, [
                      _hoisted_7,
                      _createElementVNode("i", {
                        class: _normalizeClass(["bi fs-1x text-primary", {
                      'bi-sort-up': _ctx.sortDirection,
                      'bi-sort-down': !_ctx.sortDirection,
                    }])
                      }, null, 2)
                    ])
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["bi fs-1x mr-2", {
                      'bi-patch-check-fill text-primary':
                        scope.row.status === 'confirmed',
                      'bi-patch-minus-fill text-danger':
                        scope.row.status === 'rejected',
                      'bi-patch-exclamation-fill text-warning':
                        scope.row.status === 'not_verified',
                    }]),
                        title: _ctx.generateNewsTitle(scope.row.status)
                      }, null, 10, _hoisted_9),
                      _createElementVNode("p", _hoisted_10, _toDisplayString(scope.row.id), 1)
                    ])
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                class: "py-5 px-0 w-170px align-top",
                width: _ctx.calcWidth(170),
                label: "Фото"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", null, [
                    (scope.row.photos.length > 0)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          id: 'news_carousel_' + scope.$index,
                          class: "carousel slide carousel-custom",
                          "data-bs-interval": "0"
                        }, [
                          _createElementVNode("div", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.photos, (subitem, subindex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: subindex,
                                class: _normalizeClass(["carousel-item", { active: subindex === 0 }])
                              }, [
                                _createVNode(_component_el_image, {
                                  style: {"width":"150px","height":"100px"},
                                  src: subitem.path,
                                  "preview-src-list": scope.row.previewPhotos,
                                  "initial-index": 1,
                                  fit: "cover"
                                }, null, 8, ["src", "preview-src-list"])
                              ], 2))
                            }), 128))
                          ]),
                          _createElementVNode("button", {
                            class: "carousel-control-prev",
                            type: "button",
                            "data-bs-target": '#news_carousel_' + scope.$index,
                            "data-bs-slide": "prev",
                            style: {"width":"20%"}
                          }, _hoisted_16, 8, _hoisted_13),
                          _createElementVNode("button", {
                            class: "carousel-control-next",
                            type: "button",
                            "data-bs-target": '#news_carousel_' + scope.$index,
                            "data-bs-slide": "next",
                            style: {"width":"20%"}
                          }, _hoisted_20, 8, _hoisted_17)
                        ], 8, _hoisted_11))
                      : (_openBlock(), _createBlock(_component_el_skeleton_item, {
                          key: 1,
                          variant: "image",
                          class: "w-150px h-100px"
                        }))
                  ])
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                class: "py-5 px-5 w-300px align-top",
                width: _ctx.calcWidth(300),
                label: "Название"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["my-2 flex", _ctx.rowClasses])
                  }, [
                    _createElementVNode("h4", _hoisted_21, _toDisplayString(scope.row.title), 1),
                    _createElementVNode("p", _hoisted_22, [
                      _createElementVNode("span", null, _toDisplayString(scope.row.preview_text), 1)
                    ])
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                class: "py-5 px-0 w-200px align-top",
                width: _ctx.calcWidth(200),
                label: "Модерация"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_el_checkbox_group, {
                        class: "my-2",
                        size: "small",
                        modelValue: scope.row.reasons,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.reasons) = $event)
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reasons, (reasonItem, reasonIndex) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                              key: reasonIndex,
                              label: reasonItem,
                              onChange: ($event: any) => (_ctx.checkItemOnReasonSelect(scope.$index))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(reasonItem.value.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "onChange"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    (_openBlock(), _createBlock(_component_el_collapse, {
                      class: "px-2",
                      key: scope.$index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_collapse_item, {
                          title: 
                      `Лог одобрений ${
                        scope.row.approved_log ? scope.row.approved_log.count : '?'
                      }`
                    ,
                          name: "1"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives((_openBlock(), _createElementBlock("div", null, [
                              (
                          scope.row.approved_log && scope.row.approved_log.count
                        )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    (
                            scope.row.approved_log.log &&
                              scope.row.approved_log.log.length
                          )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                          _hoisted_26,
                                          _createVNode(_component_el_timeline, null, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.approved_log.log, (reason, index) => {
                                                return (_openBlock(), _createBlock(_component_el_timeline_item, {
                                                  key: index,
                                                  timestamp: reason.date
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("strong", null, _toDisplayString(reason.moderator.name), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["timestamp"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
                            ])), [
                              [_directive_loading, scope.row.logApprovedProgress]
                            ])
                          ]),
                          _: 2
                        }, 1032, ["title"])
                      ]),
                      _: 2
                    }, 1024)),
                    (_openBlock(), _createBlock(_component_el_collapse, {
                      class: "px-2",
                      key: scope.$index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_collapse_item, {
                          title: 
                      `Лог отклонений ${
                        scope.row.rejected_log ? scope.row.rejected_log.count : '?'
                      }`
                    ,
                          name: "2"
                        }, {
                          default: _withCtx(() => [
                            (scope.row.rejected_log && scope.row.rejected_log.count)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  _createElementVNode("p", null, " Отклонено раз: " + _toDisplayString(scope.row.rejected_log.count), 1),
                                  (
                          scope.row.rejected_log.log &&
                            scope.row.rejected_log.log.length
                        )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                        _hoisted_32,
                                        _createVNode(_component_el_timeline, null, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.rejected_log.log, (reason, index) => {
                                              return (_openBlock(), _createBlock(_component_el_timeline_item, {
                                                key: index,
                                                timestamp: reason.date
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("p", _hoisted_33, _toDisplayString(reason.text), 1),
                                                  _createElementVNode("strong", null, _toDisplayString(reason.moderator.name), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["timestamp"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
                          ]),
                          _: 2
                        }, 1032, ["title"])
                      ]),
                      _: 2
                    }, 1024))
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(140),
                label: "Категория"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("p", _hoisted_37, _toDisplayString(scope.row.category.name), 1)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(170),
                label: "Товарные рубрики"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("ul", _hoisted_38, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.ad_rubrics, (subitem, subindex) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "list__item",
                          key: subindex
                        }, [
                          _createElementVNode("p", _hoisted_39, _toDisplayString(subitem.name), 1)
                        ]))
                      }), 128))
                    ])
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(150),
                label: "Источники фото"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    (scope.row.sourcesPhotos && scope.row.sourcesPhotos.name)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          class: "paragraph word-break_break-all",
                          title: scope.row.sourcesPhotos.name
                        }, _toDisplayString(scope.row.sourcesPhotos.name), 9, _hoisted_40))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(180),
                label: "Источники новости"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    (scope.row.sourcesNews && scope.row.sourcesNews.name)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          class: "paragraph",
                          title: scope.row.sourcesNews.name
                        }, _toDisplayString(scope.row.sourcesNews.name), 9, _hoisted_41))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(170),
                label: "Создано"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("p", _hoisted_42, _toDisplayString(scope.row.created_at), 1),
                    (scope.row.author)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_43, _toDisplayString(scope.row.author.name), 1))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                width: _ctx.calcWidth(170),
                label: "Изменено"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createElementVNode("p", _hoisted_44, _toDisplayString(scope.row.updated_at), 1),
                    (scope.row.author)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_45, _toDisplayString(scope.row.author.name), 1))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"]),
              _createVNode(_component_el_table_column, {
                fixed: "right",
                width: _ctx.calcWidth(60)
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.rowClasses)
                  }, [
                    _createVNode(_component_el_button_group, { class: "d-flex flex-column" }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-icon btn-active-icon-primary",
                          title: "Одобрить",
                          onClick: ($event: any) => (_ctx.allowEntry(scope.row))
                        }, _hoisted_48, 8, _hoisted_46),
                        _createElementVNode("button", _hoisted_49, [
                          _createVNode(_component_router_link, {
                            class: "btn-sm",
                            to: {
                        name: 'news-edit',
                        params: {
                          id: scope.row.id,
                          entry: JSON.stringify(scope.row),
                        },
                      }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_50
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-icon btn-active-icon-primary",
                          title: "Удалить",
                          onClick: ($event: any) => (_ctx.deleteEntry(scope.row))
                        }, _hoisted_53, 8, _hoisted_51)
                      ]),
                      _: 2
                    }, 1024)
                  ], 2)
                ]),
                _: 1
              }, 8, ["width"])
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _ctx.newsLoading]
          ]),
          (_ctx.tableHasContent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                _createVNode(_component_el_button, {
                  type: "success",
                  title: 
              !_ctx.someCheckboxesAreChecked
                ? 'Выберите хотя бы один элемент из списка'
                : 'Одобрить'
            ,
                  disabled: !_ctx.someCheckboxesAreChecked ? true : false,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.allowBulkEntries()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_55
                  ]),
                  _: 1
                }, 8, ["title", "disabled"]),
                _createVNode(_component_el_button, {
                  type: "warning",
                  title: _ctx.declineButtonTitle,
                  disabled: _ctx.bulkDeclineStatus,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.rejectBulkEntries()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_56
                  ]),
                  _: 1
                }, 8, ["title", "disabled"]),
                _createVNode(_component_el_button, {
                  type: "danger",
                  title: 
              !_ctx.someCheckboxesAreChecked
                ? 'Выберите хотя бы один элемент из списка'
                : 'Удалить'
            ,
                  disabled: !_ctx.someCheckboxesAreChecked ? true : false,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteBulkEntries()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_57
                  ]),
                  _: 1
                }, 8, ["title", "disabled"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onFilterButtonClick", "items-total", "pages-total", "current-page"])
    ])
  ]))
}